export const GET_ADMIN_ACTIVITY_LIST = 'GET_ADMIN_ACTIVITY_LIST'
export const GET_ADMIN_ACTIVITY_FILTER = 'GET_ADMIN_ACTIVITY_FILTER'
